import { getComponentsUsedInBilling } from './selectors/getComponentsUsedInBilling';
import { getComponentsUpdatesAllowed } from './selectors/getComponentsUpdatesAllowed';

export const componentsSelectors = {
  getComponentsUsedInBilling,
  getComponentsUpdatesAllowed,
};
